import { CSSObject } from '@emotion/react';
import { HoneycombStyleSystemProps, HoneycombTheme } from '../../../theming';
import { getResponsiveValue } from './getResponsiveValue';
import { SystemPropKeys, SYSTEM_PROPS } from './systemProps';

export function getSystemStyles(props: HoneycombStyleSystemProps, theme: HoneycombTheme): CSSObject {
    const styles = Object.keys(props).reduce<Array<CSSObject>>((acc, key) => {
        if (key in SYSTEM_PROPS) {
            const propKey = key as SystemPropKeys;
            const value = props[propKey];
            if (value !== undefined) {
                acc.push(getResponsiveValue(propKey, value, theme));
            }
        }
        return acc;
    }, []);

    // Compose the styles array into a single object
    return styles.reduce<CSSObject>((acc, stylesPartial) => {
        Object.keys(stylesPartial).forEach((property) => {
            let value = stylesPartial[property];
            if (typeof value === 'object' && property in acc) {
                // Append this rule to our existing media query property.
                value = { ...(acc[property] as object), ...(value as object) };
            }
            acc[property] = value;
        });
        return acc;
    }, {});
}
